export const tryOrGet = (/** @type {() => any} */ func, /** @type {any} */ defaultValue) => {
  try {
    return func()
  } catch {
    return defaultValue
  }
}

export const numberFormatCompact = (/** @type {number | bigint} */ value) =>
  Intl.NumberFormat('en-US', { notation: 'compact', compactDisplay: 'short' }).format(value)

export const numberFormat = (/** @type {number | bigint} */ value) => value.toLocaleString('en-US');

export const PAYMENT_MAP = {
  'sms': 50000,
  'email': 10000,
  'social': 50000,
}